export default {
  PAGE_TITLE: 'Filiais',
  SEARCH_LABEL: 'Nome',
  getQuestionMessageDeleteDialog: nome => `Deseja excluir a Filial ${nome}? Ao confirmar, a Filial será excluída permanentemente`,
};
